import React from 'react'
import './bookingStepper.css'
import { FaCheck } from 'react-icons/fa'

interface BookingStepperProps {
  currentStep: number
}

const steps = ['Dates & Rooms', 'Guest Details', 'Extras & Payment Options', 'Review Reservation']

const BookingStepper: React.FC<BookingStepperProps> = ({ currentStep }) => {
  return (
    <div className="booking-stepper">
      {steps.map((label, index) => {
        const stepNumber = index + 1
        const isActive = currentStep === stepNumber
        const isCompleted = currentStep > stepNumber

        return (
          <React.Fragment key={label}>
            <div className="step-item">
              <div
                className={`step-number ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
              >
                {isCompleted ? <FaCheck /> : stepNumber}
              </div>
              <div className={`step-label ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}` }>{label}</div>
            </div>

            {stepNumber < steps.length && (
              <div
                className={`step-divider ${currentStep > stepNumber ? 'solid' : ''}`}
              >
                {currentStep > stepNumber ? '─────────' : '.........'}
              </div>
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default BookingStepper
